import React from 'react';
import { Link } from 'react-router-dom';
import StarRating from './StarRating';
import './ThemeCard.css';

const ThemeCard = ({ theme }) => {
  return (
    <div className="theme-card">
      <div className="theme-header">
        <h3 className="theme-title">{theme.title}</h3>
        <span className="theme-site">{theme.site}</span>
      </div>
      <p className="theme-description">{theme.description}</p>
      <div className="theme-stats">
        <div className="stat">
          <span className="stat-label">Upvotes:</span>
          <span className="stat-value">{theme.upvotes}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Avg Rating:</span>
          <StarRating rating={theme.averageRating} readOnly />
        </div>
        <div className="stat">
          <span className="stat-label">Reviews:</span>
          <span className="stat-value">{theme.reviewCount}</span>
        </div>
      </div>
      <Link to={`/theme/${theme.id}`} className="btn btn-primary">
        View Details
      </Link>
    </div>
  );
};

export default ThemeCard;
